module.exports = __webpack_public_path__ + "media/svg-new/american-e3e3debf.svg";